<div class="grid p-fluid">
  <form [formGroup]="resultForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
    <div class="p-fluid p-formgrid grid">
      <div class="p-field col-12 md:col-6">
        <span class="p-float-label size_cent form-margin">
          <input formControlName="name" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'Tag_Name' | translate}} *</label>
        </span>
        <span class="p-float-label size_cent form-margin">
          <input formControlName="label" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'Tag_Lab' | translate}} *</label>
        </span>
      </div>
      <div class="p-field col-12 md:col-6">
        <div>{{'Desc' | translate}}</div>
        <textarea formControlName="desc" rows="4" cols="57" pInputTextarea></textarea>
      </div>
    </div>
  </form>
</div>

<div class="col-12 lg:col-12 md:col-12 align-right">
  @if (resultForm.controls['id'].value) {
    <button
      (click)="deleteItem()"
      class="p-button-danger p-button p-component p-button-text-only blockBottom margin"
      >
      {{'Delete' | translate}}
    </button>
  }
  <button
    (click)="cancel()"
    type="button"
    class="p-button-primary p-button-outlined p-button p-component p-button-text-only btn-square margin"
    >
    {{'Cancel' | translate}}
  </button>
  <button
    (click)="validate()"
    type="button"
    class="p-button p-component p-button-text-only btn-square margin"
    >
    {{'Valid' | translate}}
  </button>
</div>
